import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams, Outlet } from "react-router-dom";
import "@/App.css";
import "@/index.css";
import { I18nProvider, useI18n } from "@/i18n";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import Wizard from "@/pages/Wizard";
import Results from "@/pages/Results";
import NotFound from "@/pages/NotFound";

const VALID_LANGS = new Set(["fr", "en"]);

function LangGate() {
    const params = useParams();
    const { lang, setLang } = useI18n();

    React.useEffect(() => {
        if (params.lang && VALID_LANGS.has(params.lang) && params.lang !== lang) {
            setLang(params.lang);
        }
    }, [params.lang, lang, setLang]);

    if (params.lang && !VALID_LANGS.has(params.lang)) {
        return <Navigate to={`/${lang}`} replace />;
    }
    return <Outlet />;
}

function RootRedirect() {
    const { lang } = useI18n();
    return <Navigate to={`/${lang}`} replace />;
}

function Layout() {
    return (
        <div className="min-h-screen bg-slate-50 text-slate-900">
            <Header />
            <main id="main-content">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}

export default function App() {
    return (
        <I18nProvider>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <Toaster position="top-right" richColors />
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<RootRedirect />} />
                        <Route path=":lang" element={<LangGate />}>
                            <Route index element={<Landing />} />
                            <Route path="wizard" element={<Wizard />} />
                            <Route path="results" element={<Results />} />
                            <Route path="*" element={<NotFound />} />
                        </Route>
                    </Route>
                </Routes>
            </BrowserRouter>
        </I18nProvider>
    );
}
